import { FC } from "react";
import styles from "./AuthContainer.module.scss";

interface AuthContainerProps {
  title: string;
  subtitle: string;
  children: React.ReactNode;
  backLink?: string;
}

export const AuthContainer: FC<AuthContainerProps> = ({
  title,
  subtitle,
  children,
  backLink,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.box}>
        {backLink && (
          <a href={backLink}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.75 18.75L9 12L15.75 5.25"
                stroke="#313131"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Back to login
          </a>
        )}

        <h1 className={styles.title}>{title}</h1>
        <p className={styles.subtitle}>{subtitle}</p>

        {children}
      </div>
    </div>
  );
};
